<template>
  <div class="w-full overflow-x-scroll flex flex-column gap-x-4 py-5">
    <div
      v-for="listing of listings"
      :key="listing._id"
      class="bg-white rounded-md shadow-xl flex-none cursor-pointer hover:opacity-80 max-w-[300px]"
      @click="setSelectedListing(listing)"
    >
      <img
        :src="listing.images[0].url"
        class="aspect-video h-[200px] rounded-t-md"
        v-if="listing && listing.images && listing.images[0]"
      />
      <div class="w-full px-5 text-center text-xl">
        <span class="py-3 line-clamp-2 h-[80px]">
          {{ listing.location.address.suburb }},
          {{ listing.location.address.city }}
        </span>
        <small class="line-clamp-2">{{
          listing.location.address.streetAddress
        }}</small>
      </div>
      <div class="grid grid-cols-3 px-5">
        <div
          class="text-center py-2 flex py-auto flex flex-column justify-center"
        >
          <h4>
            <img
              src="@/assets/icons/bed.png"
              style="width: 30px; margin-right: 5px; margin-bottom: 15px"
            />
            {{ listing.description.bedrooms }}
          </h4>
        </div>
        <div
          class="text-center py-2 flex py-auto flex flex-column justify-center"
        >
          <h4>
            <img
              src="@/assets/icons/Icon1.png"
              style="width: 30px; margin-right: 5px; margin-bottom: 15px"
            />
            {{ listing.description.bathrooms }}
          </h4>
        </div>
        <div
          class="text-center py-2 flex py-auto flex flex-column justify-center"
        >
          <h4>
            <img
              src="@/assets/icons/house_cost.svg"
              style="width: 37px; margin-right: 5px"
            />
            ${{ listing.description.rent }}p/w
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapWritableState } from "pinia";
import { useListingStore } from "@/store/listing";

export default {
  name: "ListingsReel",
  props: ["listings"],
  computed: {
    ...mapWritableState(useListingStore, ["selectedListing"]),
  },
  methods: {
    setSelectedListing(listing) {
      this.selectedListing = listing;
    },
  },
};
</script>

<style scoped></style>
